import { AnchorProvider, Program, BN } from '@project-serum/anchor';
import { Keypair, PublicKey, SystemProgram, SYSVAR_RENT_PUBKEY } from '@solana/web3.js';
import { getAssociatedTokenAddress, TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } from '@solana/spl-token';
import * as base58 from 'bs58';
import * as nacl from 'tweetnacl';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var IDL = {
  "version": "0.1.0",
  "name": "game_wallet",
  "instructions": [{
    "name": "initializeTokenConfig",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenDecimal",
      "type": "u8"
    }, {
      "name": "isPaused",
      "type": "bool"
    }, {
      "name": "canDeposit",
      "type": "bool"
    }, {
      "name": "canWithdraw",
      "type": "bool"
    }, {
      "name": "canSpend",
      "type": "bool"
    }, {
      "name": "canDistribute",
      "type": "bool"
    }, {
      "name": "isWithdrawServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "withdrawServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isSpendServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "spendServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isDistributionServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "distributionServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isMinWithdrawEnable",
      "type": "bool"
    }, {
      "name": "isMaxWithdrawEnable",
      "type": "bool"
    }, {
      "name": "minWithdraw",
      "type": "u64"
    }, {
      "name": "maxWithdraw",
      "type": "u64"
    }]
  }, {
    "name": "deposit",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "depositFor",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositForTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }]
  }, {
    "name": "withdraw",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "receiver",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "receiverTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "userTokenConfigBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "withdrawWithoutUser",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "receiver",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "receiverTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "userTokenConfigBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "spend",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "userTokenConfigBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "spendWithoutUser",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "userTokenConfigBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "addDistributeSupply",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "distributionPoolBump",
      "type": "u8"
    }, {
      "name": "distributionPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }]
  }, {
    "name": "distribute",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "distributionPoolBump",
      "type": "u8"
    }, {
      "name": "distributionPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "distributeWithoutUser",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "depositPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPool",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "distributionPoolTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "depositPoolBump",
      "type": "u8"
    }, {
      "name": "depositPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "distributionPoolBump",
      "type": "u8"
    }, {
      "name": "distributionPoolTokenAccountBump",
      "type": "u8"
    }, {
      "name": "amount",
      "type": "u64"
    }, {
      "name": "nonce",
      "type": "i64"
    }]
  }, {
    "name": "updateTokenConfig",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "incomeAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "incomeTokenAccount",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "tokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "associatedTokenProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "systemProgram",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "rent",
      "isMut": false,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "tokenDecimal",
      "type": "u8"
    }, {
      "name": "isPaused",
      "type": "bool"
    }, {
      "name": "canDeposit",
      "type": "bool"
    }, {
      "name": "canWithdraw",
      "type": "bool"
    }, {
      "name": "canSpend",
      "type": "bool"
    }, {
      "name": "canDistribute",
      "type": "bool"
    }, {
      "name": "isWithdrawServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "withdrawServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isSpendServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "spendServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isDistributionServiceFeeEnable",
      "type": "bool"
    }, {
      "name": "distributionServiceFeePercentage",
      "type": "u64"
    }, {
      "name": "isMinWithdrawEnable",
      "type": "bool"
    }, {
      "name": "isMaxWithdrawEnable",
      "type": "bool"
    }, {
      "name": "minWithdraw",
      "type": "u64"
    }, {
      "name": "maxWithdraw",
      "type": "u64"
    }]
  }, {
    "name": "updateUserTokenConfig",
    "accounts": [{
      "name": "payer",
      "isMut": true,
      "isSigner": true
    }, {
      "name": "signingAuthority",
      "isMut": false,
      "isSigner": true
    }, {
      "name": "user",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenMintAccount",
      "isMut": false,
      "isSigner": false
    }, {
      "name": "tokenConfig",
      "isMut": true,
      "isSigner": false
    }, {
      "name": "userTokenConfig",
      "isMut": true,
      "isSigner": false
    }],
    "args": [{
      "name": "tokenConfigBump",
      "type": "u8"
    }, {
      "name": "userTokenConfigBump",
      "type": "u8"
    }, {
      "name": "isActive",
      "type": "bool"
    }, {
      "name": "canDeposit",
      "type": "bool"
    }, {
      "name": "canWithdraw",
      "type": "bool"
    }, {
      "name": "canSpend",
      "type": "bool"
    }, {
      "name": "canDistribute",
      "type": "bool"
    }]
  }],
  "accounts": [{
    "name": "depositPoolAccount",
    "type": {
      "kind": "struct",
      "fields": [{
        "name": "tokenAccount",
        "type": "publicKey"
      }, {
        "name": "currentValue",
        "type": "u64"
      }, {
        "name": "totalValue",
        "type": "u64"
      }]
    }
  }, {
    "name": "distributionPoolAccount",
    "type": {
      "kind": "struct",
      "fields": [{
        "name": "tokenAccount",
        "type": "publicKey"
      }, {
        "name": "currentValue",
        "type": "u64"
      }, {
        "name": "totalValue",
        "type": "u64"
      }]
    }
  }, {
    "name": "tokenConfigAccount",
    "type": {
      "kind": "struct",
      "fields": [{
        "name": "signingAuthority",
        "type": "publicKey"
      }, {
        "name": "tokenMintAccount",
        "type": "publicKey"
      }, {
        "name": "tokenDecimal",
        "type": "u8"
      }, {
        "name": "isPaused",
        "type": "bool"
      }, {
        "name": "canDeposit",
        "type": "bool"
      }, {
        "name": "canWithdraw",
        "type": "bool"
      }, {
        "name": "canSpend",
        "type": "bool"
      }, {
        "name": "canDistribute",
        "type": "bool"
      }, {
        "name": "isWithdrawServiceFeeEnable",
        "type": "bool"
      }, {
        "name": "withdrawServiceFeePercentage",
        "type": "u64"
      }, {
        "name": "isSpendServiceFeeEnable",
        "type": "bool"
      }, {
        "name": "spendServiceFeePercentage",
        "type": "u64"
      }, {
        "name": "isDistributionServiceFeeEnable",
        "type": "bool"
      }, {
        "name": "distributionServiceFeePercentage",
        "type": "u64"
      }, {
        "name": "isMinWithdrawEnable",
        "type": "bool"
      }, {
        "name": "isMaxWithdrawEnable",
        "type": "bool"
      }, {
        "name": "minWithdraw",
        "type": "u64"
      }, {
        "name": "maxWithdraw",
        "type": "u64"
      }, {
        "name": "depositPool",
        "type": "publicKey"
      }, {
        "name": "incomeAccount",
        "type": "publicKey"
      }, {
        "name": "distributionPool",
        "type": "publicKey"
      }, {
        "name": "lastUsedBlockTimestamp",
        "type": "i64"
      }]
    }
  }, {
    "name": "userTokenConfigAccount",
    "type": {
      "kind": "struct",
      "fields": [{
        "name": "user",
        "type": "publicKey"
      }, {
        "name": "currentValue",
        "type": "u64"
      }, {
        "name": "totalDepositValue",
        "type": "u64"
      }, {
        "name": "totalWithdrawValue",
        "type": "u64"
      }, {
        "name": "totalSpendValue",
        "type": "u64"
      }, {
        "name": "totalDistributeValue",
        "type": "u64"
      }, {
        "name": "totalServiceFeeValue",
        "type": "u64"
      }, {
        "name": "isActive",
        "type": "bool"
      }, {
        "name": "canDeposit",
        "type": "bool"
      }, {
        "name": "canWithdraw",
        "type": "bool"
      }, {
        "name": "canSpend",
        "type": "bool"
      }, {
        "name": "canDistribute",
        "type": "bool"
      }, {
        "name": "lastUsedBlockTimestamp",
        "type": "i64"
      }, {
        "name": "lastGameAction",
        "type": {
          "defined": "GameAction"
        }
      }]
    }
  }],
  "types": [{
    "name": "GameAction",
    "type": {
      "kind": "enum",
      "variants": [{
        "name": "None"
      }, {
        "name": "Deposit"
      }, {
        "name": "Withdraw"
      }, {
        "name": "Spend"
      }, {
        "name": "Distribute"
      }]
    }
  }],
  "errors": [{
    "code": 6000,
    "name": "InvalidSigningAuthority",
    "msg": "Invalid Signing Authority"
  }, {
    "code": 6001,
    "name": "InvalidIncomeAccount",
    "msg": "Invalid Income Account"
  }, {
    "code": 6002,
    "name": "Paused",
    "msg": "Paused"
  }, {
    "code": 6003,
    "name": "InvalidWithdrawServiceFee",
    "msg": "Invalid Withdraw Service Fee"
  }, {
    "code": 6004,
    "name": "InvalidSpendServiceFee",
    "msg": "Invalid Spend Service Fee"
  }, {
    "code": 6005,
    "name": "InvalidDistributionServiceFee",
    "msg": "Invalid Distribution Service Fee"
  }, {
    "code": 6006,
    "name": "InvalidMinWithdraw",
    "msg": "Invalid Min Withdraw"
  }, {
    "code": 6007,
    "name": "InvalidMaxWithdraw",
    "msg": "Invalid Max Withdraw"
  }, {
    "code": 6008,
    "name": "InvalidMinMaxWithdraw",
    "msg": "Invalid Min Max Withdraw"
  }, {
    "code": 6009,
    "name": "DepositIsDisable",
    "msg": "Deposit Is Disable"
  }, {
    "code": 6010,
    "name": "UserDepositIsDisable",
    "msg": "User Deposit Is Disable"
  }, {
    "code": 6011,
    "name": "WithdrawIsDisable",
    "msg": "User Withdraw Is Disable"
  }, {
    "code": 6012,
    "name": "UserWithdrawIsDisable",
    "msg": "User Withdraw Is Disable"
  }, {
    "code": 6013,
    "name": "SpendIsDisable",
    "msg": "User Spend Is Disable"
  }, {
    "code": 6014,
    "name": "UserSpendIsDisable",
    "msg": "User Spend Is Disable"
  }, {
    "code": 6015,
    "name": "DistributeIsDisable",
    "msg": "User Distribute Is Disable"
  }, {
    "code": 6016,
    "name": "UserDistributeIsDisable",
    "msg": "User Distribute Is Disable"
  }, {
    "code": 6017,
    "name": "UserIsNotActive",
    "msg": "User Is Not Active"
  }, {
    "code": 6018,
    "name": "InvalidTimestamp",
    "msg": "Invalid Timestamp"
  }, {
    "code": 6019,
    "name": "InvalidAmount",
    "msg": "Invalid Amount"
  }]
};

var TOKEN_CONFIG_ACCOUNT_PREFIX = "CONFIG";
var DEPOSIT_POOL_ACCOUNT_PREFIX = "DEPOSIT";
var DISTRIBUTION_POOL_ACCOUNT_PREFIX = "DISTRIBUTION";
var USER_TOKEN_CONFIG_ACCOUNT_PREFIX = "USER";
var GameWalletLib = /*#__PURE__*/function () {
  function GameWalletLib(programId, connection, wallet) {
    _classCallCheck(this, GameWalletLib);

    this.connection = connection;
    var provider = new AnchorProvider(connection, wallet, AnchorProvider.defaultOptions());
    this.program = new Program(IDL, programId, provider);
  }
  /**
   * Sign the transaction and add the signature in the transaction.
   * @param tx Transaction object which needs to sign.
   * @param secretKey Transaction signer secret key (secret key in base58 string).
   */


  _createClass(GameWalletLib, [{
    key: "signTransaction",
    value: function signTransaction(tx, secretKey) {
      var keypair = Keypair.fromSecretKey(base58.decode(secretKey));
      var signature = nacl.sign.detached(tx.serializeMessage(), keypair.secretKey);
      tx.addSignature(keypair.publicKey, Buffer.from(signature));
      return tx;
    }
    /**
     * Add signature in the transaction.
     * @param tx Transaction object where signature needs to add.
     * @param signerAddress Signer public key from which secret key transaction is signed.
     * @param signature Signed transaction message signature.
     */

  }, {
    key: "addSignatureInTransaction",
    value: function addSignatureInTransaction(tx, signerAddress, signature) {
      tx.addSignature(signerAddress, signature);
      return tx;
    }
    /**
     * Add signature in the transaction.
     * @param tx Transaction object where signature needs to add.
     * @param feePayer public key of the address which going to pay the fee.
     */

  }, {
    key: "addFeePayerAndRecentBlockHashInTransaction",
    value: function () {
      var _addFeePayerAndRecentBlockHashInTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tx, feePayer) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tx.feePayer = feePayer;
                _context.next = 3;
                return this.connection.getLatestBlockhash();

              case 3:
                tx.recentBlockhash = _context.sent.blockhash;
                return _context.abrupt("return", tx);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addFeePayerAndRecentBlockHashInTransaction(_x, _x2) {
        return _addFeePayerAndRecentBlockHashInTransaction.apply(this, arguments);
      }

      return addFeePayerAndRecentBlockHashInTransaction;
    }()
    /**
     * Get token config account pda and bump.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getTokenConfigAccountPdaAndBump",
    value: function () {
      var _getTokenConfigAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tokenMintAccount) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(TOKEN_CONFIG_ACCOUNT_PREFIX), tokenMintAccount.toBuffer()], this.program.programId);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getTokenConfigAccountPdaAndBump(_x3) {
        return _getTokenConfigAccountPdaAndBump.apply(this, arguments);
      }

      return getTokenConfigAccountPdaAndBump;
    }()
    /**
     * Get deposit pool account pda and bump.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getDepositPoolAccountPdaAndBump",
    value: function () {
      var _getDepositPoolAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tokenMintAccount) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(DEPOSIT_POOL_ACCOUNT_PREFIX), tokenMintAccount.toBuffer()], this.program.programId);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getDepositPoolAccountPdaAndBump(_x4) {
        return _getDepositPoolAccountPdaAndBump.apply(this, arguments);
      }

      return getDepositPoolAccountPdaAndBump;
    }()
    /**
     * Get deposit pool token account pda and bump.
     * @param depositPoolPda public key of deposit pool account.
     */

  }, {
    key: "getDepositPoolTokenAccountPdaAndBump",
    value: function () {
      var _getDepositPoolTokenAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(depositPoolPda) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(DEPOSIT_POOL_ACCOUNT_PREFIX), depositPoolPda.toBuffer()], this.program.programId);

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getDepositPoolTokenAccountPdaAndBump(_x5) {
        return _getDepositPoolTokenAccountPdaAndBump.apply(this, arguments);
      }

      return getDepositPoolTokenAccountPdaAndBump;
    }()
    /**
     * Get deposit pool account pda and bump.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getDistributionPoolAccountPdaAndBump",
    value: function () {
      var _getDistributionPoolAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(tokenMintAccount) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(DISTRIBUTION_POOL_ACCOUNT_PREFIX), tokenMintAccount.toBuffer()], this.program.programId);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDistributionPoolAccountPdaAndBump(_x6) {
        return _getDistributionPoolAccountPdaAndBump.apply(this, arguments);
      }

      return getDistributionPoolAccountPdaAndBump;
    }()
    /**
     * Get deposit pool token account pda and bump.
     * @param distributionPoolPda public key of distribution pool account.
     */

  }, {
    key: "getDistributionPoolTokenAccountPdaAndBump",
    value: function () {
      var _getDistributionPoolTokenAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(distributionPoolPda) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(DISTRIBUTION_POOL_ACCOUNT_PREFIX), distributionPoolPda.toBuffer()], this.program.programId);

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getDistributionPoolTokenAccountPdaAndBump(_x7) {
        return _getDistributionPoolTokenAccountPdaAndBump.apply(this, arguments);
      }

      return getDistributionPoolTokenAccountPdaAndBump;
    }()
    /**
     * Get user token config account pda and bump.
     * @param tokenMintAccount public key of the token mint account.
     * @param user public key of user account
     */

  }, {
    key: "getUserTokenConfigAccountPdaAndBump",
    value: function () {
      var _getUserTokenConfigAccountPdaAndBump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(tokenMintAccount, user) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return PublicKey.findProgramAddress([Buffer.from(USER_TOKEN_CONFIG_ACCOUNT_PREFIX), tokenMintAccount.toBuffer(), user.toBuffer()], this.program.programId);

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUserTokenConfigAccountPdaAndBump(_x8, _x9) {
        return _getUserTokenConfigAccountPdaAndBump.apply(this, arguments);
      }

      return getUserTokenConfigAccountPdaAndBump;
    }()
    /**
     * Get token config account pda data.
     * @param tokenConfigAccountPda token config account pda.
     */

  }, {
    key: "getTokenConfigAccountPdaData",
    value: function () {
      var _getTokenConfigAccountPdaData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(tokenConfigAccountPda) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.program.account.tokenConfigAccount.fetch(tokenConfigAccountPda);

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getTokenConfigAccountPdaData(_x10) {
        return _getTokenConfigAccountPdaData.apply(this, arguments);
      }

      return getTokenConfigAccountPdaData;
    }()
    /**
     * Get user token config account pda data.
     * @param userTokenConfigAccountPda user token config account pda.
     */

  }, {
    key: "getUserTokenConfigAccountPdaData",
    value: function () {
      var _getUserTokenConfigAccountPdaData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(userTokenConfigAccountPda) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.program.account.userTokenConfigAccount.fetch(userTokenConfigAccountPda);

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getUserTokenConfigAccountPdaData(_x11) {
        return _getUserTokenConfigAccountPdaData.apply(this, arguments);
      }

      return getUserTokenConfigAccountPdaData;
    }()
    /**
     * Get deposit pool account pda data.
     * @param depositPoolAccountPda deposit pool account pda.
     */

  }, {
    key: "getDepositPoolAccountPdaData",
    value: function () {
      var _getDepositPoolAccountPdaData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(depositPoolAccountPda) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.program.account.depositPoolAccount.fetch(depositPoolAccountPda);

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getDepositPoolAccountPdaData(_x12) {
        return _getDepositPoolAccountPdaData.apply(this, arguments);
      }

      return getDepositPoolAccountPdaData;
    }()
    /**
     * Get distribution pool account pda data.
     * @param distributionPoolAccountPda distribution pool account pda.
     */

  }, {
    key: "getDistributionPoolAccountPdaData",
    value: function () {
      var _getDistributionPoolAccountPdaData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(distributionPoolAccountPda) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.program.account.distributionPoolAccount.fetch(distributionPoolAccountPda);

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getDistributionPoolAccountPdaData(_x13) {
        return _getDistributionPoolAccountPdaData.apply(this, arguments);
      }

      return getDistributionPoolAccountPdaData;
    }()
    /**
     * Get all token config account data.
     */

  }, {
    key: "getAllTokenConfigAccountData",
    value: function () {
      var _getAllTokenConfigAccountData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.program.account.tokenConfigAccount.all();

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getAllTokenConfigAccountData() {
        return _getAllTokenConfigAccountData.apply(this, arguments);
      }

      return getAllTokenConfigAccountData;
    }()
    /**
     * Get all user token config account data.
     */

  }, {
    key: "getAllUserTokenConfigAccountData",
    value: function () {
      var _getAllUserTokenConfigAccountData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.program.account.userTokenConfigAccount.all();

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getAllUserTokenConfigAccountData() {
        return _getAllUserTokenConfigAccountData.apply(this, arguments);
      }

      return getAllUserTokenConfigAccountData;
    }()
    /**
     * Get all deposit pool account data.
     */

  }, {
    key: "getAllDepositPoolAccountData",
    value: function () {
      var _getAllDepositPoolAccountData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.program.account.depositPoolAccount.all();

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getAllDepositPoolAccountData() {
        return _getAllDepositPoolAccountData.apply(this, arguments);
      }

      return getAllDepositPoolAccountData;
    }()
    /**
     * Get all distribution pool account data.
     */

  }, {
    key: "getAllDistributionPoolAccountData",
    value: function () {
      var _getAllDistributionPoolAccountData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.program.account.distributionPoolAccount.all();

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getAllDistributionPoolAccountData() {
        return _getAllDistributionPoolAccountData.apply(this, arguments);
      }

      return getAllDistributionPoolAccountData;
    }()
    /**
     * Is pda address initialize.
     */

  }, {
    key: "isPdaAddressInitialize",
    value: function () {
      var _isPdaAddressInitialize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(pdaAddress) {
        var pdaAccountInfo;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.connection.getAccountInfo(pdaAddress);

              case 2:
                pdaAccountInfo = _context16.sent;
                return _context16.abrupt("return", pdaAccountInfo != null);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function isPdaAddressInitialize(_x14) {
        return _isPdaAddressInitialize.apply(this, arguments);
      }

      return isPdaAddressInitialize;
    }()
    /**
     * get token config account pda and is initialized.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getTokenConfigAccountPdaAndIsInitialized",
    value: function () {
      var _getTokenConfigAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(tokenMintAccount) {
        var _yield$this$getTokenC, _yield$this$getTokenC2, tokenConfigAccountPda, tokenConfigAccountBump, isTokenConfigAccountPda;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.getTokenConfigAccountPdaAndBump(tokenMintAccount);

              case 2:
                _yield$this$getTokenC = _context17.sent;
                _yield$this$getTokenC2 = _slicedToArray(_yield$this$getTokenC, 2);
                tokenConfigAccountPda = _yield$this$getTokenC2[0];
                tokenConfigAccountBump = _yield$this$getTokenC2[1];
                _context17.next = 8;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 8:
                isTokenConfigAccountPda = _context17.sent;

                if (isTokenConfigAccountPda) {
                  _context17.next = 11;
                  break;
                }

                throw Error('token config account is not initialized');

              case 11:
                return _context17.abrupt("return", [tokenConfigAccountPda, tokenConfigAccountBump]);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getTokenConfigAccountPdaAndIsInitialized(_x15) {
        return _getTokenConfigAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getTokenConfigAccountPdaAndIsInitialized;
    }()
    /**
     * get deposit pool account pda and is initialized.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getDepositPoolAccountPdaAndIsInitialized",
    value: function () {
      var _getDepositPoolAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(tokenMintAccount) {
        var _yield$this$getDeposi, _yield$this$getDeposi2, depositPoolAccountPda, depositPoolAccountBump, isDepositPoolAccountPda;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.getDepositPoolAccountPdaAndBump(tokenMintAccount);

              case 2:
                _yield$this$getDeposi = _context18.sent;
                _yield$this$getDeposi2 = _slicedToArray(_yield$this$getDeposi, 2);
                depositPoolAccountPda = _yield$this$getDeposi2[0];
                depositPoolAccountBump = _yield$this$getDeposi2[1];
                _context18.next = 8;
                return this.isPdaAddressInitialize(depositPoolAccountPda);

              case 8:
                isDepositPoolAccountPda = _context18.sent;

                if (isDepositPoolAccountPda) {
                  _context18.next = 11;
                  break;
                }

                throw Error('deposit pool account is not initialized');

              case 11:
                return _context18.abrupt("return", [depositPoolAccountPda, depositPoolAccountBump]);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getDepositPoolAccountPdaAndIsInitialized(_x16) {
        return _getDepositPoolAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getDepositPoolAccountPdaAndIsInitialized;
    }()
    /**
     * Get deposit pool token account pda and is initialized.
     * @param depositPoolPda public key of deposit pool account.
     */

  }, {
    key: "getDepositPoolTokenAccountPdaAndIsInitialized",
    value: function () {
      var _getDepositPoolTokenAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(depositPoolPda) {
        var _yield$this$getDeposi3, _yield$this$getDeposi4, depositPoolTokenAccountPda, depositPoolTokenAccountBump, isDepositPoolTokenAccountPda;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getDepositPoolTokenAccountPdaAndBump(depositPoolPda);

              case 2:
                _yield$this$getDeposi3 = _context19.sent;
                _yield$this$getDeposi4 = _slicedToArray(_yield$this$getDeposi3, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi4[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi4[1];
                _context19.next = 8;
                return this.isPdaAddressInitialize(depositPoolTokenAccountPda);

              case 8:
                isDepositPoolTokenAccountPda = _context19.sent;

                if (isDepositPoolTokenAccountPda) {
                  _context19.next = 11;
                  break;
                }

                throw Error('deposit pool token account is not initialized');

              case 11:
                return _context19.abrupt("return", [depositPoolTokenAccountPda, depositPoolTokenAccountBump]);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getDepositPoolTokenAccountPdaAndIsInitialized(_x17) {
        return _getDepositPoolTokenAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getDepositPoolTokenAccountPdaAndIsInitialized;
    }()
    /**
     * Get deposit pool account pda and is initialized.
     * @param tokenMintAccount public key of the token mint account.
     */

  }, {
    key: "getDistributionPoolAccountPdaAndIsInitialized",
    value: function () {
      var _getDistributionPoolAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(tokenMintAccount) {
        var _yield$this$getDistri, _yield$this$getDistri2, distributionPoolAccountPda, distributionPoolAccountBump, isDistributionPoolAccountPda;

        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.getDistributionPoolAccountPdaAndBump(tokenMintAccount);

              case 2:
                _yield$this$getDistri = _context20.sent;
                _yield$this$getDistri2 = _slicedToArray(_yield$this$getDistri, 2);
                distributionPoolAccountPda = _yield$this$getDistri2[0];
                distributionPoolAccountBump = _yield$this$getDistri2[1];
                _context20.next = 8;
                return this.isPdaAddressInitialize(distributionPoolAccountPda);

              case 8:
                isDistributionPoolAccountPda = _context20.sent;

                if (isDistributionPoolAccountPda) {
                  _context20.next = 11;
                  break;
                }

                throw Error('distribution pool account is not initialized');

              case 11:
                return _context20.abrupt("return", [distributionPoolAccountPda, distributionPoolAccountBump]);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getDistributionPoolAccountPdaAndIsInitialized(_x18) {
        return _getDistributionPoolAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getDistributionPoolAccountPdaAndIsInitialized;
    }()
    /**
     * Get deposit pool token account pda and is initialized.
     * @param distributionPoolPda public key of distribution pool account.
     */

  }, {
    key: "getDistributionPoolTokenAccountPdaAndIsInitialized",
    value: function () {
      var _getDistributionPoolTokenAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(distributionPoolPda) {
        var _yield$this$getDistri3, _yield$this$getDistri4, distributionPoolTokenAccountPda, distributionPoolTokenAccountBump, isDistributionPoolTokenAccountPda;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.getDistributionPoolTokenAccountPdaAndBump(distributionPoolPda);

              case 2:
                _yield$this$getDistri3 = _context21.sent;
                _yield$this$getDistri4 = _slicedToArray(_yield$this$getDistri3, 2);
                distributionPoolTokenAccountPda = _yield$this$getDistri4[0];
                distributionPoolTokenAccountBump = _yield$this$getDistri4[1];
                _context21.next = 8;
                return this.isPdaAddressInitialize(distributionPoolTokenAccountPda);

              case 8:
                isDistributionPoolTokenAccountPda = _context21.sent;

                if (isDistributionPoolTokenAccountPda) {
                  _context21.next = 11;
                  break;
                }

                throw Error('distribution pool token account is not initialized');

              case 11:
                return _context21.abrupt("return", [distributionPoolTokenAccountPda, distributionPoolTokenAccountBump]);

              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getDistributionPoolTokenAccountPdaAndIsInitialized(_x19) {
        return _getDistributionPoolTokenAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getDistributionPoolTokenAccountPdaAndIsInitialized;
    }()
    /**
     * Get user token config account pda and is initialized.
     * @param tokenMintAccount public key of the token mint account.
     * @param user public key of user account
     */

  }, {
    key: "getUserTokenConfigAccountPdaAndIsInitialized",
    value: function () {
      var _getUserTokenConfigAccountPdaAndIsInitialized = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(tokenMintAccount, user) {
        var _yield$this$getUserTo, _yield$this$getUserTo2, userTokenConfigAccountPda, userTokenConfigAccountBump, isUserTokenConfigAccountPda;

        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.getUserTokenConfigAccountPdaAndBump(tokenMintAccount, user);

              case 2:
                _yield$this$getUserTo = _context22.sent;
                _yield$this$getUserTo2 = _slicedToArray(_yield$this$getUserTo, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo2[0];
                userTokenConfigAccountBump = _yield$this$getUserTo2[1];
                _context22.next = 8;
                return this.isPdaAddressInitialize(userTokenConfigAccountPda);

              case 8:
                isUserTokenConfigAccountPda = _context22.sent;

                if (isUserTokenConfigAccountPda) {
                  _context22.next = 11;
                  break;
                }

                throw Error('user token config account is not initialized');

              case 11:
                return _context22.abrupt("return", [userTokenConfigAccountPda, userTokenConfigAccountBump]);

              case 12:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getUserTokenConfigAccountPdaAndIsInitialized(_x20, _x21) {
        return _getUserTokenConfigAccountPdaAndIsInitialized.apply(this, arguments);
      }

      return getUserTokenConfigAccountPdaAndIsInitialized;
    }() // Create Transaction

    /**
     * Create initialize token config transaction.
     * @param tokenDecimal decimal points of token mint account
     * @param isPaused is program is paused
     * @param canDeposit is program allow token deposit
     * @param canWithdraw is program allow token withdrawal
     * @param canSpend is program allow token spending
     * @param canDistribute is program allow token distribution
     * @param isWithdrawServiceFeeEnable is program allow withdrawal service fee
     * @param withdrawServiceFeePercentage withdraw service fee percentage
     * @param isSpendServiceFeeEnable is program allow spending service fee
     * @param spendServiceFeePercentage spend service fee percentage
     * @param isDistributionServiceFeeEnable is program allow distribution service fee
     * @param distributionServiceFeePercentage distribution service fee percentage
     * @param isMinWithdrawEnable is program allow min withdraw token amount
     * @param isMaxWithdrawEnable is program allow max withdraw token amount
     * @param minWithdraw min withdraw token amount
     * @param maxWithdraw max withdraw token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createInitializeTokenConfigTransaction",
    value: function () {
      var _createInitializeTokenConfigTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(tokenDecimal, isPaused, canDeposit, canWithdraw, canSpend, canDistribute, isWithdrawServiceFeeEnable, withdrawServiceFeePercentage, isSpendServiceFeeEnable, spendServiceFeePercentage, isDistributionServiceFeeEnable, distributionServiceFeePercentage, isMinWithdrawEnable, isMaxWithdrawEnable, minWithdraw, maxWithdraw, payer, signingAuthority, tokenMintAccount, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            _yield$this$getTokenC3,
            _yield$this$getTokenC4,
            tokenConfigAccountPda,
            _yield$this$getDeposi5,
            _yield$this$getDeposi6,
            depositPoolAccountPda,
            _yield$this$getDeposi7,
            _yield$this$getDeposi8,
            depositPoolTokenAccountPda,
            _yield$this$getDistri5,
            _yield$this$getDistri6,
            distributionPoolAccountPda,
            _yield$this$getDistri7,
            _yield$this$getDistri8,
            distributionPoolTokenAccountPda,
            incomeTokenAccount,
            tx,
            _args23 = arguments;

        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                tokenProgram = _args23.length > 20 && _args23[20] !== undefined ? _args23[20] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args23.length > 21 && _args23[21] !== undefined ? _args23[21] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args23.length > 22 && _args23[22] !== undefined ? _args23[22] : SystemProgram.programId;
                rent = _args23.length > 23 && _args23[23] !== undefined ? _args23[23] : SYSVAR_RENT_PUBKEY;
                _context23.next = 6;
                return this.getTokenConfigAccountPdaAndBump(tokenMintAccount);

              case 6:
                _yield$this$getTokenC3 = _context23.sent;
                _yield$this$getTokenC4 = _slicedToArray(_yield$this$getTokenC3, 1);
                tokenConfigAccountPda = _yield$this$getTokenC4[0];
                _context23.next = 11;
                return this.getDepositPoolAccountPdaAndBump(tokenMintAccount);

              case 11:
                _yield$this$getDeposi5 = _context23.sent;
                _yield$this$getDeposi6 = _slicedToArray(_yield$this$getDeposi5, 1);
                depositPoolAccountPda = _yield$this$getDeposi6[0];
                _context23.next = 16;
                return this.getDepositPoolTokenAccountPdaAndBump(depositPoolAccountPda);

              case 16:
                _yield$this$getDeposi7 = _context23.sent;
                _yield$this$getDeposi8 = _slicedToArray(_yield$this$getDeposi7, 1);
                depositPoolTokenAccountPda = _yield$this$getDeposi8[0];
                _context23.next = 21;
                return this.getDistributionPoolAccountPdaAndBump(tokenMintAccount);

              case 21:
                _yield$this$getDistri5 = _context23.sent;
                _yield$this$getDistri6 = _slicedToArray(_yield$this$getDistri5, 1);
                distributionPoolAccountPda = _yield$this$getDistri6[0];
                _context23.next = 26;
                return this.getDistributionPoolTokenAccountPdaAndBump(distributionPoolAccountPda);

              case 26:
                _yield$this$getDistri7 = _context23.sent;
                _yield$this$getDistri8 = _slicedToArray(_yield$this$getDistri7, 1);
                distributionPoolTokenAccountPda = _yield$this$getDistri8[0];
                _context23.next = 31;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 31:
                incomeTokenAccount = _context23.sent;
                _context23.next = 34;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 34:
                if (!_context23.sent) {
                  _context23.next = 36;
                  break;
                }

                throw Error('token config account is initialized');

              case 36:
                _context23.next = 38;
                return this.program.methods.initializeTokenConfig(tokenDecimal, isPaused, canDeposit, canWithdraw, canSpend, canDistribute, isWithdrawServiceFeeEnable, new BN(withdrawServiceFeePercentage), isSpendServiceFeeEnable, new BN(spendServiceFeePercentage), isDistributionServiceFeeEnable, new BN(distributionServiceFeePercentage), isMinWithdrawEnable, isMaxWithdrawEnable, new BN(minWithdraw), new BN(maxWithdraw)).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  distributionPool: distributionPoolAccountPda,
                  distributionPoolTokenAccount: distributionPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 38:
                tx = _context23.sent;
                _context23.next = 41;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 41:
                return _context23.abrupt("return", tx);

              case 42:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function createInitializeTokenConfigTransaction(_x22, _x23, _x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35, _x36, _x37, _x38, _x39, _x40, _x41) {
        return _createInitializeTokenConfigTransaction.apply(this, arguments);
      }

      return createInitializeTokenConfigTransaction;
    }()
    /**
     * create update token config transaction.
     * @param tokenDecimal decimal points of token mint account
     * @param isPaused is program is paused
     * @param canDeposit is program allow token deposit
     * @param canWithdraw is program allow token withdrawal
     * @param canSpend is program allow token spending
     * @param canDistribute is program allow token distribution
     * @param isWithdrawServiceFeeEnable is program allow withdrawal service fee
     * @param withdrawServiceFeePercentage withdraw service fee percentage
     * @param isSpendServiceFeeEnable is program allow spending service fee
     * @param spendServiceFeePercentage spend service fee percentage
     * @param isDistributionServiceFeeEnable is program allow distribution service fee
     * @param distributionServiceFeePercentage distribution service fee percentage
     * @param isMinWithdrawEnable is program allow min withdraw token amount
     * @param isMaxWithdrawEnable is program allow max withdraw token amount
     * @param minWithdraw min withdraw token amount
     * @param maxWithdraw max withdraw token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createUpdateTokenConfigTransaction",
    value: function () {
      var _createUpdateTokenConfigTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(tokenDecimal, isPaused, canDeposit, canWithdraw, canSpend, canDistribute, isWithdrawServiceFeeEnable, withdrawServiceFeePercentage, isSpendServiceFeeEnable, spendServiceFeePercentage, isDistributionServiceFeeEnable, distributionServiceFeePercentage, isMinWithdrawEnable, isMaxWithdrawEnable, minWithdraw, maxWithdraw, payer, signingAuthority, tokenMintAccount, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            _yield$this$getTokenC5,
            _yield$this$getTokenC6,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            incomeTokenAccount,
            tx,
            _args24 = arguments;

        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                tokenProgram = _args24.length > 20 && _args24[20] !== undefined ? _args24[20] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args24.length > 21 && _args24[21] !== undefined ? _args24[21] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args24.length > 22 && _args24[22] !== undefined ? _args24[22] : SystemProgram.programId;
                rent = _args24.length > 23 && _args24[23] !== undefined ? _args24[23] : SYSVAR_RENT_PUBKEY;
                _context24.next = 6;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 6:
                _yield$this$getTokenC5 = _context24.sent;
                _yield$this$getTokenC6 = _slicedToArray(_yield$this$getTokenC5, 2);
                tokenConfigAccountPda = _yield$this$getTokenC6[0];
                tokenConfigAccountBump = _yield$this$getTokenC6[1];
                _context24.next = 12;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 12:
                incomeTokenAccount = _context24.sent;
                _context24.next = 15;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 15:
                if (_context24.sent) {
                  _context24.next = 17;
                  break;
                }

                throw Error('token config account is not initialized');

              case 17:
                _context24.next = 19;
                return this.program.methods.updateTokenConfig(tokenConfigAccountBump, tokenDecimal, isPaused, canDeposit, canWithdraw, canSpend, canDistribute, isWithdrawServiceFeeEnable, new BN(withdrawServiceFeePercentage), isSpendServiceFeeEnable, new BN(spendServiceFeePercentage), isDistributionServiceFeeEnable, new BN(distributionServiceFeePercentage), isMinWithdrawEnable, isMaxWithdrawEnable, new BN(minWithdraw), new BN(maxWithdraw)).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 19:
                tx = _context24.sent;
                _context24.next = 22;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 22:
                return _context24.abrupt("return", tx);

              case 23:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function createUpdateTokenConfigTransaction(_x42, _x43, _x44, _x45, _x46, _x47, _x48, _x49, _x50, _x51, _x52, _x53, _x54, _x55, _x56, _x57, _x58, _x59, _x60, _x61) {
        return _createUpdateTokenConfigTransaction.apply(this, arguments);
      }

      return createUpdateTokenConfigTransaction;
    }()
    /**
     * create deposit transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param depositFor public key of the account which deposit is make
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createDepositTransaction",
    value: function () {
      var _createDepositTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(amount, payer, signingAuthority, tokenMintAccount, user, depositFor) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            _yield$this$getTokenC7,
            _yield$this$getTokenC8,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi9,
            _yield$this$getDeposi10,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi11,
            _yield$this$getDeposi12,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            userTokenAccount,
            _yield$this$getUserTo3,
            _yield$this$getUserTo4,
            userTokenConfigAccountPda,
            tx,
            _args25 = arguments;

        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                tokenProgram = _args25.length > 6 && _args25[6] !== undefined ? _args25[6] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args25.length > 7 && _args25[7] !== undefined ? _args25[7] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args25.length > 8 && _args25[8] !== undefined ? _args25[8] : SystemProgram.programId;
                rent = _args25.length > 9 && _args25[9] !== undefined ? _args25[9] : SYSVAR_RENT_PUBKEY;
                _context25.next = 6;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 6:
                _yield$this$getTokenC7 = _context25.sent;
                _yield$this$getTokenC8 = _slicedToArray(_yield$this$getTokenC7, 2);
                tokenConfigAccountPda = _yield$this$getTokenC8[0];
                tokenConfigAccountBump = _yield$this$getTokenC8[1];
                _context25.next = 12;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 12:
                _yield$this$getDeposi9 = _context25.sent;
                _yield$this$getDeposi10 = _slicedToArray(_yield$this$getDeposi9, 2);
                depositPoolAccountPda = _yield$this$getDeposi10[0];
                depositPoolAccountBump = _yield$this$getDeposi10[1];
                _context25.next = 18;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 18:
                _yield$this$getDeposi11 = _context25.sent;
                _yield$this$getDeposi12 = _slicedToArray(_yield$this$getDeposi11, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi12[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi12[1];
                _context25.next = 24;
                return getAssociatedTokenAddress(tokenMintAccount, user);

              case 24:
                userTokenAccount = _context25.sent;
                _context25.next = 27;
                return this.getUserTokenConfigAccountPdaAndBump(tokenMintAccount, depositFor);

              case 27:
                _yield$this$getUserTo3 = _context25.sent;
                _yield$this$getUserTo4 = _slicedToArray(_yield$this$getUserTo3, 1);
                userTokenConfigAccountPda = _yield$this$getUserTo4[0];
                _context25.next = 32;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 32:
                if (_context25.sent) {
                  _context25.next = 34;
                  break;
                }

                throw Error('token config account is not initialized');

              case 34:
                _context25.next = 36;
                return this.program.methods.deposit(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, new BN(amount)).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  depositFor: depositFor,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  depositForTokenConfig: userTokenConfigAccountPda,
                  userTokenAccount: userTokenAccount,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 36:
                tx = _context25.sent;
                _context25.next = 39;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 39:
                return _context25.abrupt("return", tx);

              case 40:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function createDepositTransaction(_x62, _x63, _x64, _x65, _x66, _x67) {
        return _createDepositTransaction.apply(this, arguments);
      }

      return createDepositTransaction;
    }()
    /**
     * create withdraw transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param incomeAccount income account public key
     * @param receiver receiver public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createWithdrawTransaction",
    value: function () {
      var _createWithdrawTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount, receiver) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC9,
            _yield$this$getTokenC10,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi13,
            _yield$this$getDeposi14,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi15,
            _yield$this$getDeposi16,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            userTokenAccount,
            receiverTokenAccount,
            incomeTokenAccount,
            _yield$this$getUserTo5,
            _yield$this$getUserTo6,
            userTokenConfigAccountPda,
            userTokenConfigAccountBump,
            tx,
            _args26 = arguments;

        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                tokenProgram = _args26.length > 7 && _args26[7] !== undefined ? _args26[7] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args26.length > 8 && _args26[8] !== undefined ? _args26[8] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args26.length > 9 && _args26[9] !== undefined ? _args26[9] : SystemProgram.programId;
                rent = _args26.length > 10 && _args26[10] !== undefined ? _args26[10] : SYSVAR_RENT_PUBKEY;
                _context26.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context26.sent;
                _context26.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC9 = _context26.sent;
                _yield$this$getTokenC10 = _slicedToArray(_yield$this$getTokenC9, 2);
                tokenConfigAccountPda = _yield$this$getTokenC10[0];
                tokenConfigAccountBump = _yield$this$getTokenC10[1];
                _context26.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi13 = _context26.sent;
                _yield$this$getDeposi14 = _slicedToArray(_yield$this$getDeposi13, 2);
                depositPoolAccountPda = _yield$this$getDeposi14[0];
                depositPoolAccountBump = _yield$this$getDeposi14[1];
                _context26.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi15 = _context26.sent;
                _yield$this$getDeposi16 = _slicedToArray(_yield$this$getDeposi15, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi16[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi16[1];
                _context26.next = 27;
                return getAssociatedTokenAddress(tokenMintAccount, user);

              case 27:
                userTokenAccount = _context26.sent;
                _context26.next = 30;
                return getAssociatedTokenAddress(tokenMintAccount, receiver);

              case 30:
                receiverTokenAccount = _context26.sent;
                _context26.next = 33;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 33:
                incomeTokenAccount = _context26.sent;
                _context26.next = 36;
                return this.getUserTokenConfigAccountPdaAndIsInitialized(tokenMintAccount, user);

              case 36:
                _yield$this$getUserTo5 = _context26.sent;
                _yield$this$getUserTo6 = _slicedToArray(_yield$this$getUserTo5, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo6[0];
                userTokenConfigAccountBump = _yield$this$getUserTo6[1];
                _context26.next = 42;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 42:
                if (_context26.sent) {
                  _context26.next = 44;
                  break;
                }

                throw Error('token config account is not initialized');

              case 44:
                _context26.next = 46;
                return this.program.methods.withdraw(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, userTokenConfigAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  userTokenAccount: userTokenAccount,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  receiver: receiver,
                  receiverTokenAccount: receiverTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 46:
                tx = _context26.sent;
                _context26.next = 49;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 49:
                return _context26.abrupt("return", tx);

              case 50:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function createWithdrawTransaction(_x68, _x69, _x70, _x71, _x72, _x73, _x74) {
        return _createWithdrawTransaction.apply(this, arguments);
      }

      return createWithdrawTransaction;
    }()
    /**
     * create withdraw without user transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param incomeAccount income account public key
     * @param receiver receiver public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createWithdrawWithoutUserTransaction",
    value: function () {
      var _createWithdrawWithoutUserTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount, receiver) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC11,
            _yield$this$getTokenC12,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi17,
            _yield$this$getDeposi18,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi19,
            _yield$this$getDeposi20,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            userTokenAccount,
            receiverTokenAccount,
            incomeTokenAccount,
            _yield$this$getUserTo7,
            _yield$this$getUserTo8,
            userTokenConfigAccountPda,
            userTokenConfigAccountBump,
            tx,
            _args27 = arguments;

        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                tokenProgram = _args27.length > 7 && _args27[7] !== undefined ? _args27[7] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args27.length > 8 && _args27[8] !== undefined ? _args27[8] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args27.length > 9 && _args27[9] !== undefined ? _args27[9] : SystemProgram.programId;
                rent = _args27.length > 10 && _args27[10] !== undefined ? _args27[10] : SYSVAR_RENT_PUBKEY;
                _context27.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context27.sent;
                _context27.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC11 = _context27.sent;
                _yield$this$getTokenC12 = _slicedToArray(_yield$this$getTokenC11, 2);
                tokenConfigAccountPda = _yield$this$getTokenC12[0];
                tokenConfigAccountBump = _yield$this$getTokenC12[1];
                _context27.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi17 = _context27.sent;
                _yield$this$getDeposi18 = _slicedToArray(_yield$this$getDeposi17, 2);
                depositPoolAccountPda = _yield$this$getDeposi18[0];
                depositPoolAccountBump = _yield$this$getDeposi18[1];
                _context27.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi19 = _context27.sent;
                _yield$this$getDeposi20 = _slicedToArray(_yield$this$getDeposi19, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi20[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi20[1];
                _context27.next = 27;
                return getAssociatedTokenAddress(tokenMintAccount, user);

              case 27:
                userTokenAccount = _context27.sent;
                _context27.next = 30;
                return getAssociatedTokenAddress(tokenMintAccount, receiver);

              case 30:
                receiverTokenAccount = _context27.sent;
                _context27.next = 33;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 33:
                incomeTokenAccount = _context27.sent;
                _context27.next = 36;
                return this.getUserTokenConfigAccountPdaAndIsInitialized(tokenMintAccount, user);

              case 36:
                _yield$this$getUserTo7 = _context27.sent;
                _yield$this$getUserTo8 = _slicedToArray(_yield$this$getUserTo7, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo8[0];
                userTokenConfigAccountBump = _yield$this$getUserTo8[1];
                _context27.next = 42;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 42:
                if (_context27.sent) {
                  _context27.next = 44;
                  break;
                }

                throw Error('token config account is not initialized');

              case 44:
                _context27.next = 46;
                return this.program.methods.withdrawWithoutUser(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, userTokenConfigAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  userTokenAccount: userTokenAccount,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  receiver: receiver,
                  receiverTokenAccount: receiverTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 46:
                tx = _context27.sent;
                _context27.next = 49;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 49:
                return _context27.abrupt("return", tx);

              case 50:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function createWithdrawWithoutUserTransaction(_x75, _x76, _x77, _x78, _x79, _x80, _x81) {
        return _createWithdrawWithoutUserTransaction.apply(this, arguments);
      }

      return createWithdrawWithoutUserTransaction;
    }()
    /**
     * create spend transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createSpendTransaction",
    value: function () {
      var _createSpendTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC13,
            _yield$this$getTokenC14,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi21,
            _yield$this$getDeposi22,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi23,
            _yield$this$getDeposi24,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            incomeTokenAccount,
            _yield$this$getUserTo9,
            _yield$this$getUserTo10,
            userTokenConfigAccountPda,
            userTokenConfigAccountBump,
            tx,
            _args28 = arguments;

        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                tokenProgram = _args28.length > 6 && _args28[6] !== undefined ? _args28[6] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args28.length > 7 && _args28[7] !== undefined ? _args28[7] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args28.length > 8 && _args28[8] !== undefined ? _args28[8] : SystemProgram.programId;
                rent = _args28.length > 9 && _args28[9] !== undefined ? _args28[9] : SYSVAR_RENT_PUBKEY;
                _context28.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context28.sent;
                _context28.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC13 = _context28.sent;
                _yield$this$getTokenC14 = _slicedToArray(_yield$this$getTokenC13, 2);
                tokenConfigAccountPda = _yield$this$getTokenC14[0];
                tokenConfigAccountBump = _yield$this$getTokenC14[1];
                _context28.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi21 = _context28.sent;
                _yield$this$getDeposi22 = _slicedToArray(_yield$this$getDeposi21, 2);
                depositPoolAccountPda = _yield$this$getDeposi22[0];
                depositPoolAccountBump = _yield$this$getDeposi22[1];
                _context28.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi23 = _context28.sent;
                _yield$this$getDeposi24 = _slicedToArray(_yield$this$getDeposi23, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi24[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi24[1];
                _context28.next = 27;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 27:
                incomeTokenAccount = _context28.sent;
                _context28.next = 30;
                return this.getUserTokenConfigAccountPdaAndIsInitialized(tokenMintAccount, user);

              case 30:
                _yield$this$getUserTo9 = _context28.sent;
                _yield$this$getUserTo10 = _slicedToArray(_yield$this$getUserTo9, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo10[0];
                userTokenConfigAccountBump = _yield$this$getUserTo10[1];
                _context28.next = 36;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 36:
                if (_context28.sent) {
                  _context28.next = 38;
                  break;
                }

                throw Error('token config account is not initialized');

              case 38:
                _context28.next = 40;
                return this.program.methods.spend(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, userTokenConfigAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 40:
                tx = _context28.sent;
                _context28.next = 43;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 43:
                return _context28.abrupt("return", tx);

              case 44:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function createSpendTransaction(_x82, _x83, _x84, _x85, _x86, _x87) {
        return _createSpendTransaction.apply(this, arguments);
      }

      return createSpendTransaction;
    }()
    /**
     * Create spend without user transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createSpendWithoutUserTransaction",
    value: function () {
      var _createSpendWithoutUserTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC15,
            _yield$this$getTokenC16,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi25,
            _yield$this$getDeposi26,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi27,
            _yield$this$getDeposi28,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            incomeTokenAccount,
            _yield$this$getUserTo11,
            _yield$this$getUserTo12,
            userTokenConfigAccountPda,
            userTokenConfigAccountBump,
            tx,
            _args29 = arguments;

        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                tokenProgram = _args29.length > 6 && _args29[6] !== undefined ? _args29[6] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args29.length > 7 && _args29[7] !== undefined ? _args29[7] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args29.length > 8 && _args29[8] !== undefined ? _args29[8] : SystemProgram.programId;
                rent = _args29.length > 9 && _args29[9] !== undefined ? _args29[9] : SYSVAR_RENT_PUBKEY;
                _context29.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context29.sent;
                _context29.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC15 = _context29.sent;
                _yield$this$getTokenC16 = _slicedToArray(_yield$this$getTokenC15, 2);
                tokenConfigAccountPda = _yield$this$getTokenC16[0];
                tokenConfigAccountBump = _yield$this$getTokenC16[1];
                _context29.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi25 = _context29.sent;
                _yield$this$getDeposi26 = _slicedToArray(_yield$this$getDeposi25, 2);
                depositPoolAccountPda = _yield$this$getDeposi26[0];
                depositPoolAccountBump = _yield$this$getDeposi26[1];
                _context29.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi27 = _context29.sent;
                _yield$this$getDeposi28 = _slicedToArray(_yield$this$getDeposi27, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi28[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi28[1];
                _context29.next = 27;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 27:
                incomeTokenAccount = _context29.sent;
                _context29.next = 30;
                return this.getUserTokenConfigAccountPdaAndIsInitialized(tokenMintAccount, user);

              case 30:
                _yield$this$getUserTo11 = _context29.sent;
                _yield$this$getUserTo12 = _slicedToArray(_yield$this$getUserTo11, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo12[0];
                userTokenConfigAccountBump = _yield$this$getUserTo12[1];
                _context29.next = 36;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 36:
                if (_context29.sent) {
                  _context29.next = 38;
                  break;
                }

                throw Error('token config account is not initialized');

              case 38:
                _context29.next = 40;
                return this.program.methods.spendWithoutUser(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, userTokenConfigAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 40:
                tx = _context29.sent;
                _context29.next = 43;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 43:
                return _context29.abrupt("return", tx);

              case 44:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function createSpendWithoutUserTransaction(_x88, _x89, _x90, _x91, _x92, _x93) {
        return _createSpendWithoutUserTransaction.apply(this, arguments);
      }

      return createSpendWithoutUserTransaction;
    }()
    /**
     * Create add distribute supply transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createAddDistributeSupplyTransaction",
    value: function () {
      var _createAddDistributeSupplyTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(amount, payer, signingAuthority, tokenMintAccount, user) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            _yield$this$getTokenC17,
            _yield$this$getTokenC18,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDistri9,
            _yield$this$getDistri10,
            distributionPoolAccountPda,
            distributionPoolAccountBump,
            _yield$this$getDistri11,
            _yield$this$getDistri12,
            distributionPoolTokenAccountPda,
            distributionPoolTokenAccountBump,
            userTokenAccount,
            tx,
            _args30 = arguments;

        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                tokenProgram = _args30.length > 5 && _args30[5] !== undefined ? _args30[5] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args30.length > 6 && _args30[6] !== undefined ? _args30[6] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args30.length > 7 && _args30[7] !== undefined ? _args30[7] : SystemProgram.programId;
                rent = _args30.length > 8 && _args30[8] !== undefined ? _args30[8] : SYSVAR_RENT_PUBKEY;
                _context30.next = 6;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 6:
                _yield$this$getTokenC17 = _context30.sent;
                _yield$this$getTokenC18 = _slicedToArray(_yield$this$getTokenC17, 2);
                tokenConfigAccountPda = _yield$this$getTokenC18[0];
                tokenConfigAccountBump = _yield$this$getTokenC18[1];
                _context30.next = 12;
                return this.getDistributionPoolAccountPdaAndBump(tokenMintAccount);

              case 12:
                _yield$this$getDistri9 = _context30.sent;
                _yield$this$getDistri10 = _slicedToArray(_yield$this$getDistri9, 2);
                distributionPoolAccountPda = _yield$this$getDistri10[0];
                distributionPoolAccountBump = _yield$this$getDistri10[1];
                _context30.next = 18;
                return this.getDistributionPoolTokenAccountPdaAndBump(distributionPoolAccountPda);

              case 18:
                _yield$this$getDistri11 = _context30.sent;
                _yield$this$getDistri12 = _slicedToArray(_yield$this$getDistri11, 2);
                distributionPoolTokenAccountPda = _yield$this$getDistri12[0];
                distributionPoolTokenAccountBump = _yield$this$getDistri12[1];
                _context30.next = 24;
                return getAssociatedTokenAddress(tokenMintAccount, user);

              case 24:
                userTokenAccount = _context30.sent;
                _context30.next = 27;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 27:
                if (_context30.sent) {
                  _context30.next = 29;
                  break;
                }

                throw Error('token config account is not initialized');

              case 29:
                _context30.next = 31;
                return this.program.methods.addDistributeSupply(tokenConfigAccountBump, distributionPoolAccountBump, distributionPoolTokenAccountBump, new BN(amount)).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenAccount: userTokenAccount,
                  distributionPool: distributionPoolAccountPda,
                  distributionPoolTokenAccount: distributionPoolTokenAccountPda,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 31:
                tx = _context30.sent;
                _context30.next = 34;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 34:
                return _context30.abrupt("return", tx);

              case 35:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function createAddDistributeSupplyTransaction(_x94, _x95, _x96, _x97, _x98) {
        return _createAddDistributeSupplyTransaction.apply(this, arguments);
      }

      return createAddDistributeSupplyTransaction;
    }()
    /**
     * Create add distribute supply transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createDistributeTransaction",
    value: function () {
      var _createDistributeTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC19,
            _yield$this$getTokenC20,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi29,
            _yield$this$getDeposi30,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi31,
            _yield$this$getDeposi32,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            _yield$this$getDistri13,
            _yield$this$getDistri14,
            distributionPoolAccountPda,
            distributionPoolAccountBump,
            _yield$this$getDistri15,
            _yield$this$getDistri16,
            distributionPoolTokenAccountPda,
            distributionPoolTokenAccountBump,
            incomeTokenAccount,
            _yield$this$getUserTo13,
            _yield$this$getUserTo14,
            userTokenConfigAccountPda,
            tx,
            _args31 = arguments;

        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                tokenProgram = _args31.length > 6 && _args31[6] !== undefined ? _args31[6] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args31.length > 7 && _args31[7] !== undefined ? _args31[7] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args31.length > 8 && _args31[8] !== undefined ? _args31[8] : SystemProgram.programId;
                rent = _args31.length > 9 && _args31[9] !== undefined ? _args31[9] : SYSVAR_RENT_PUBKEY;
                _context31.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context31.sent;
                _context31.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC19 = _context31.sent;
                _yield$this$getTokenC20 = _slicedToArray(_yield$this$getTokenC19, 2);
                tokenConfigAccountPda = _yield$this$getTokenC20[0];
                tokenConfigAccountBump = _yield$this$getTokenC20[1];
                _context31.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi29 = _context31.sent;
                _yield$this$getDeposi30 = _slicedToArray(_yield$this$getDeposi29, 2);
                depositPoolAccountPda = _yield$this$getDeposi30[0];
                depositPoolAccountBump = _yield$this$getDeposi30[1];
                _context31.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi31 = _context31.sent;
                _yield$this$getDeposi32 = _slicedToArray(_yield$this$getDeposi31, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi32[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi32[1];
                _context31.next = 27;
                return this.getDistributionPoolAccountPdaAndBump(tokenMintAccount);

              case 27:
                _yield$this$getDistri13 = _context31.sent;
                _yield$this$getDistri14 = _slicedToArray(_yield$this$getDistri13, 2);
                distributionPoolAccountPda = _yield$this$getDistri14[0];
                distributionPoolAccountBump = _yield$this$getDistri14[1];
                _context31.next = 33;
                return this.getDistributionPoolTokenAccountPdaAndBump(distributionPoolAccountPda);

              case 33:
                _yield$this$getDistri15 = _context31.sent;
                _yield$this$getDistri16 = _slicedToArray(_yield$this$getDistri15, 2);
                distributionPoolTokenAccountPda = _yield$this$getDistri16[0];
                distributionPoolTokenAccountBump = _yield$this$getDistri16[1];
                _context31.next = 39;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 39:
                incomeTokenAccount = _context31.sent;
                _context31.next = 42;
                return this.getUserTokenConfigAccountPdaAndBump(tokenMintAccount, user);

              case 42:
                _yield$this$getUserTo13 = _context31.sent;
                _yield$this$getUserTo14 = _slicedToArray(_yield$this$getUserTo13, 1);
                userTokenConfigAccountPda = _yield$this$getUserTo14[0];
                _context31.next = 47;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 47:
                if (_context31.sent) {
                  _context31.next = 49;
                  break;
                }

                throw Error('token config account is not initialized');

              case 49:
                _context31.next = 51;
                return this.program.methods.distribute(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, distributionPoolAccountBump, distributionPoolTokenAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  distributionPool: distributionPoolAccountPda,
                  distributionPoolTokenAccount: distributionPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 51:
                tx = _context31.sent;
                _context31.next = 54;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 54:
                return _context31.abrupt("return", tx);

              case 55:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function createDistributeTransaction(_x99, _x100, _x101, _x102, _x103, _x104) {
        return _createDistributeTransaction.apply(this, arguments);
      }

      return createDistributeTransaction;
    }()
    /**
     * Create distribute without user transaction.
     * @param amount token amount
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     * @param incomeAccount income account public key
     * @param tokenProgram token program id
     * @param associatedTokenProgram associated token program id
     * @param systemProgram system program id
     * @param rent rent program id
     */

  }, {
    key: "createDistributeWithoutUserTransaction",
    value: function () {
      var _createDistributeWithoutUserTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32(amount, payer, signingAuthority, tokenMintAccount, user, incomeAccount) {
        var tokenProgram,
            associatedTokenProgram,
            systemProgram,
            rent,
            currentBlockTime,
            _yield$this$getTokenC21,
            _yield$this$getTokenC22,
            tokenConfigAccountPda,
            tokenConfigAccountBump,
            _yield$this$getDeposi33,
            _yield$this$getDeposi34,
            depositPoolAccountPda,
            depositPoolAccountBump,
            _yield$this$getDeposi35,
            _yield$this$getDeposi36,
            depositPoolTokenAccountPda,
            depositPoolTokenAccountBump,
            _yield$this$getDistri17,
            _yield$this$getDistri18,
            distributionPoolAccountPda,
            distributionPoolAccountBump,
            _yield$this$getDistri19,
            _yield$this$getDistri20,
            distributionPoolTokenAccountPda,
            distributionPoolTokenAccountBump,
            incomeTokenAccount,
            _yield$this$getUserTo15,
            _yield$this$getUserTo16,
            userTokenConfigAccountPda,
            tx,
            _args32 = arguments;

        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                tokenProgram = _args32.length > 6 && _args32[6] !== undefined ? _args32[6] : TOKEN_PROGRAM_ID;
                associatedTokenProgram = _args32.length > 7 && _args32[7] !== undefined ? _args32[7] : ASSOCIATED_TOKEN_PROGRAM_ID;
                systemProgram = _args32.length > 8 && _args32[8] !== undefined ? _args32[8] : SystemProgram.programId;
                rent = _args32.length > 9 && _args32[9] !== undefined ? _args32[9] : SYSVAR_RENT_PUBKEY;
                _context32.next = 6;
                return this.getCurrentBlockTime();

              case 6:
                currentBlockTime = _context32.sent;
                _context32.next = 9;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 9:
                _yield$this$getTokenC21 = _context32.sent;
                _yield$this$getTokenC22 = _slicedToArray(_yield$this$getTokenC21, 2);
                tokenConfigAccountPda = _yield$this$getTokenC22[0];
                tokenConfigAccountBump = _yield$this$getTokenC22[1];
                _context32.next = 15;
                return this.getDepositPoolAccountPdaAndIsInitialized(tokenMintAccount);

              case 15:
                _yield$this$getDeposi33 = _context32.sent;
                _yield$this$getDeposi34 = _slicedToArray(_yield$this$getDeposi33, 2);
                depositPoolAccountPda = _yield$this$getDeposi34[0];
                depositPoolAccountBump = _yield$this$getDeposi34[1];
                _context32.next = 21;
                return this.getDepositPoolTokenAccountPdaAndIsInitialized(depositPoolAccountPda);

              case 21:
                _yield$this$getDeposi35 = _context32.sent;
                _yield$this$getDeposi36 = _slicedToArray(_yield$this$getDeposi35, 2);
                depositPoolTokenAccountPda = _yield$this$getDeposi36[0];
                depositPoolTokenAccountBump = _yield$this$getDeposi36[1];
                _context32.next = 27;
                return this.getDistributionPoolAccountPdaAndBump(tokenMintAccount);

              case 27:
                _yield$this$getDistri17 = _context32.sent;
                _yield$this$getDistri18 = _slicedToArray(_yield$this$getDistri17, 2);
                distributionPoolAccountPda = _yield$this$getDistri18[0];
                distributionPoolAccountBump = _yield$this$getDistri18[1];
                _context32.next = 33;
                return this.getDistributionPoolTokenAccountPdaAndBump(distributionPoolAccountPda);

              case 33:
                _yield$this$getDistri19 = _context32.sent;
                _yield$this$getDistri20 = _slicedToArray(_yield$this$getDistri19, 2);
                distributionPoolTokenAccountPda = _yield$this$getDistri20[0];
                distributionPoolTokenAccountBump = _yield$this$getDistri20[1];
                _context32.next = 39;
                return getAssociatedTokenAddress(tokenMintAccount, incomeAccount);

              case 39:
                incomeTokenAccount = _context32.sent;
                _context32.next = 42;
                return this.getUserTokenConfigAccountPdaAndBump(tokenMintAccount, user);

              case 42:
                _yield$this$getUserTo15 = _context32.sent;
                _yield$this$getUserTo16 = _slicedToArray(_yield$this$getUserTo15, 1);
                userTokenConfigAccountPda = _yield$this$getUserTo16[0];
                _context32.next = 47;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 47:
                if (_context32.sent) {
                  _context32.next = 49;
                  break;
                }

                throw Error('token config account is not initialized');

              case 49:
                _context32.next = 51;
                return this.program.methods.distributeWithoutUser(tokenConfigAccountBump, depositPoolAccountBump, depositPoolTokenAccountBump, distributionPoolAccountBump, distributionPoolTokenAccountBump, new BN(amount), currentBlockTime).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  user: user,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  userTokenConfig: userTokenConfigAccountPda,
                  depositPool: depositPoolAccountPda,
                  depositPoolTokenAccount: depositPoolTokenAccountPda,
                  distributionPool: distributionPoolAccountPda,
                  distributionPoolTokenAccount: distributionPoolTokenAccountPda,
                  incomeAccount: incomeAccount,
                  incomeTokenAccount: incomeTokenAccount,
                  tokenProgram: tokenProgram,
                  associatedTokenProgram: associatedTokenProgram,
                  systemProgram: systemProgram,
                  rent: rent
                }).transaction();

              case 51:
                tx = _context32.sent;
                _context32.next = 54;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 54:
                return _context32.abrupt("return", tx);

              case 55:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function createDistributeWithoutUserTransaction(_x105, _x106, _x107, _x108, _x109, _x110) {
        return _createDistributeWithoutUserTransaction.apply(this, arguments);
      }

      return createDistributeWithoutUserTransaction;
    }()
    /**
     * create update user token config transaction.
     * @param isActive is user account active
     * @param canDeposit is program allow token deposit
     * @param canWithdraw is program allow token withdrawal
     * @param canSpend is program allow token spending
     * @param canDistribute is program allow token distribution
     * @param payer transaction fee payer public key
     * @param signingAuthority signing authority public key
     * @param tokenMintAccount token mint account public key
     * @param user user public key
     */

  }, {
    key: "createUpdateUserTokenConfigTransaction",
    value: function () {
      var _createUpdateUserTokenConfigTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33(isActive, canDeposit, canWithdraw, canSpend, canDistribute, payer, signingAuthority, tokenMintAccount, user) {
        var _yield$this$getTokenC23, _yield$this$getTokenC24, tokenConfigAccountPda, tokenConfigAccountBump, _yield$this$getUserTo17, _yield$this$getUserTo18, userTokenConfigAccountPda, userTokenConfigAccountBump, tx;

        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.getTokenConfigAccountPdaAndIsInitialized(tokenMintAccount);

              case 2:
                _yield$this$getTokenC23 = _context33.sent;
                _yield$this$getTokenC24 = _slicedToArray(_yield$this$getTokenC23, 2);
                tokenConfigAccountPda = _yield$this$getTokenC24[0];
                tokenConfigAccountBump = _yield$this$getTokenC24[1];
                _context33.next = 8;
                return this.getUserTokenConfigAccountPdaAndIsInitialized(tokenMintAccount, user);

              case 8:
                _yield$this$getUserTo17 = _context33.sent;
                _yield$this$getUserTo18 = _slicedToArray(_yield$this$getUserTo17, 2);
                userTokenConfigAccountPda = _yield$this$getUserTo18[0];
                userTokenConfigAccountBump = _yield$this$getUserTo18[1];
                _context33.next = 14;
                return this.isPdaAddressInitialize(tokenConfigAccountPda);

              case 14:
                if (_context33.sent) {
                  _context33.next = 16;
                  break;
                }

                throw Error('token config account is not initialized');

              case 16:
                _context33.next = 18;
                return this.program.methods.updateUserTokenConfig(tokenConfigAccountBump, userTokenConfigAccountBump, isActive, canDeposit, canWithdraw, canSpend, canDistribute).accounts({
                  payer: payer,
                  signingAuthority: signingAuthority,
                  tokenMintAccount: tokenMintAccount,
                  tokenConfig: tokenConfigAccountPda,
                  user: user,
                  userTokenConfig: userTokenConfigAccountPda
                }).transaction();

              case 18:
                tx = _context33.sent;
                _context33.next = 21;
                return this.addFeePayerAndRecentBlockHashInTransaction(tx, payer);

              case 21:
                return _context33.abrupt("return", tx);

              case 22:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function createUpdateUserTokenConfigTransaction(_x111, _x112, _x113, _x114, _x115, _x116, _x117, _x118, _x119) {
        return _createUpdateUserTokenConfigTransaction.apply(this, arguments);
      }

      return createUpdateUserTokenConfigTransaction;
    }()
  }, {
    key: "getCurrentBlockTime",
    value: function () {
      var _getCurrentBlockTime = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
        return regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.t0 = BN;
                _context34.t1 = this.connection;
                _context34.next = 4;
                return this.connection.getSlot(undefined);

              case 4:
                _context34.t2 = _context34.sent;
                _context34.next = 7;
                return _context34.t1.getBlockTime.call(_context34.t1, _context34.t2);

              case 7:
                _context34.t3 = _context34.sent;
                return _context34.abrupt("return", new _context34.t0(_context34.t3));

              case 9:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function getCurrentBlockTime() {
        return _getCurrentBlockTime.apply(this, arguments);
      }

      return getCurrentBlockTime;
    }()
  }]);

  return GameWalletLib;
}();

var GAME_WALLET_PROGRAM_ID = new PublicKey('8EiozskbhZ7Y9a5gxJQbNvuDtbabchg2YhYDWanKBXs2');
var GAME_WALLET_PROGRAM_ID_MAIN_NET = new PublicKey('8EiozskbhZ7Y9a5gxJQbNvuDtbabchg2YhYDWanKBXs2');

export { GAME_WALLET_PROGRAM_ID, GAME_WALLET_PROGRAM_ID_MAIN_NET, GameWalletLib, IDL };
